import { lodash } from '../lang';
import { dayjs, TimeInstance, TimeInput, TimeStep } from './dayjs';

export const DayJS = dayjs;

export function fromEpoch(epoch: number, options?: { utc?: boolean }) {
  return (options?.utc === false ? dayjs : dayjs.utc)(epoch * 1000);
}

export function toInstance(input: TimeInstance | number, options?: { epoch?: boolean; utc?: boolean }) {
  const creator = options?.utc === false ? dayjs : dayjs.utc;

  if (dayjs.isDayjs(input)) {
    return input;
  } else if (lodash.isDate(input)) {
    return dayjs(input);
  } else if (lodash.isNumber(input)) {
    return creator(options?.epoch !== false ? input * 1000 : input);
  } else if (lodash.isString(input)) {
    const date = creator(input);
    return date.isValid() ? date : input;
  }

  return input;
}

export function create(input: TimeInput, options?: { utc?: boolean; format?: string }) {
  return (options?.utc === false ? dayjs : dayjs.utc)(input, options?.format);
}

export function now(options?: { utc?: boolean }) {
  return (options?.utc === false ? dayjs : dayjs.utc)();
}

export function format(instance: TimeInstance, format?: string) {
  return instance.format(format);
}

export function range(
  from: number | TimeInstance,
  to: number | TimeInstance,
  step: TimeStep = 'day',
  inclusive = true,
) {
  const dates: TimeInstance[] = [];

  let end = toInstance(to, { epoch: true }).endOf(step);
  let date = toInstance(from, { epoch: true }).startOf(step);

  if (!inclusive) end = end.subtract(1, step);

  do {
    dates.push(date);
    date = date.add(1, step).startOf(step);
  } while (date.isSameOrBefore(end, step));

  return dates;
}
